import React from "react";
import PropTypes from "prop-types";
import { Grid, Row, Col, DropdownButton,
	MenuItem, Button, Image } from "react-bootstrap";
import { availableLocales } from "../lng/Locales";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import "./Kopfzeile.css";

const renderLocaleItem = (locale, i, selectLocale) => (
	<MenuItem key={i} eventKey={locale.locale}
		onClick={ () => { selectLocale(locale.locale); } }>
		<FormattedMessage id={locale.i18n_key} />
	</MenuItem>
);

const sdStateToImageFilename = sd_status => (
	sd_status === 1 ? "/symSDgruen25x29.png"
		: "/symSDrot25x29.png"
);

const sdStateToI18nKey = sd_status => ([
	/* 0 */ "No SD-card",
	/* 1 */ "SD-card OK",
	/* 2 */ "SD-card write-protected",
	/* 3 */ "SD-card not writable",
	/* 4 */ "SD-card is full"
][sd_status]);

const Kopfzeile = props => (
	<Grid componentClass="header" className="Kopfzeile">
		<Row>
			<Col xs={12}>
				<div className="Kopfzeile-Inhalt">
					<DropdownButton id="choose_language"
						title={props.intl.formatMessage({ id:props.locale_i18n_key })}
						className="Kopfzeile-Sprache">
						{ availableLocales.map((locale, i) => (
							renderLocaleItem(locale, i, props.selectLocale)
						))}
					</DropdownButton>
					<a target="_blank" href="https://www.almig.de/ueber-uns/kontakt.html"
						rel="noopener noreferrer">
						<FormattedMessage id="Contact" />
					</a>
					<Button onClick={props.logout} disabled={!props.authorized}>
						<FormattedMessage id="Logout" />
					</Button>
					{ !props.authorized ? null
						: <div className="sd-status">
							<Image src={sdStateToImageFilename(props.sd_status)} />
							<FormattedMessage id={sdStateToI18nKey(props.sd_status) || "unknown"} />
						</div>}
				</div>
			</Col>
		</Row>
	</Grid>
);

Kopfzeile.propTypes = {
	intl: intlShape.isRequired,
	locale_i18n_key: PropTypes.string.isRequired,
	selectLocale: PropTypes.func.isRequired,
	authorized: PropTypes.bool.isRequired,
	logout: PropTypes.func.isRequired,
	sd_status: PropTypes.number.isRequired
};

export default injectIntl(Kopfzeile);
